/** Settings shell: page titles (pocket header, rows, search hub), the root page and shared load/save lines. */
export default {
  pageRoot: "Settings",
  pageAccount: "Account",
  pageAccountPassword: "Change password",
  pageAccountInvoices: "Invoices",
  pageAccountDelete: "Delete account",
  pagePreferences: "Preferences",
  pagePreferencesAppearance: "Appearance",
  pagePreferencesVoice: "Voice",
  pagePreferencesVoicePrompts: "Shortcut and prompts",
  pagePreferencesVoicePromptEdit: "Prompt",
  pagePreferencesVoiceVocabulary: "Vocabulary",
  pagePreferencesVoiceVocabularyWord: "Word",
  pagePreferencesSounds: "Sounds",
  pagePreferencesScreen: "Screen and pointer",
  pagePreferencesShortcuts: "Keyboard shortcuts",
  pagePreferencesShortcutEdit: "Change shortcut",
  pagePreferencesUpdates: "Updates",
  pagePreferencesPrivacy: "Privacy",
  pagePreferencesAiTools: "AI tools",
  pagePlugins: "Plugins",
  pagePluginsBrowse: "Browse",
  pagePluginsPlugin: "Plugin",
  pageConnections: "Connections",
  pageConnectionsTool: "AI tool",
  pageConnectionsApp: "App",
  pageConnectionsBrowser: "Browser",
  pageConnectionsSafari: "Safari",
  pageConnectionsAddApp: "Add an app",
  pageConnectionsUsage: "AI usage",
  pageProjects: "Projects",
  pageProjectsNew: "New project",
  pageProjectsProject: "Project",
  pageProjectsFolder: "Folder",
  pageProjectsGit: "Git",
  pageProjectsDevServer: "Dev server",
  pageProjectsAddFolder: "Add folder",
  pageSkills: "Skills",
  pageSkillsSkill: "Skill",
  pageSkillsCustomize: "Customize for me",
  pageSkillsBrowse: "Browse skills",
  pageMemory: "Memory",
  pageMemoryProposal: "To review",
  pageMemorySummaries: "Conversation summaries",
  pageHelp: "Help",
  pageHelpCommunity: "Community",
  upgrade: "Upgrade",
  paymentFailed: "Payment failed",
  memoryToReview: "{count} to review",
  loadingNoun: "Loading {noun}…",
  loadFailedNoun: "Could not load {noun}.",
  retryNoun: "Retry {noun}",
  retry: "Retry",
  saveFailed: "Couldn’t save. Try again.",
} as const;
